const TEMPLATE_TYPES = {
  reply: 'REPLY',
  systemOnboarding: 'SYSTEM_ONBOARDING',
  systemTicketing: 'SYSTEM_TICKETING',
  customTicketing: 'CUSTOM_TICKETING',
  systemClient: 'SYSTEM_CLIENT',
  systemTask: 'SYSTEM_TASK',
  systemAsset: 'SYSTEM_ASSET',
  chat: 'CHAT',
  sideConversation: 'SIDE_CONVERSATION',
  //   customAsset: 'CUSTOM_ASSET',
  //   system: 'SYSTEM',
  //   report: 'REPORT',
  //   alerts: 'ALERTS',
  invoice: 'INVOICE'
};

const TEMPLATE_SUB_TYPES = {
  technician: 'TECHNICIAN',
  requester: 'REQUESTER',
  user: 'USER'
  //   none: 'NONE'
};

const TEMPLATE_SUBTYPE_KEYS = {
  [TEMPLATE_SUB_TYPES.technician]:
    'admin.emailNotification.technicianNotification.header',
  [TEMPLATE_SUB_TYPES.requester]:
    'admin.emailNotification.requesterNotification.header'
};

const TEMPLATE_URL_PATHS = {
  [TEMPLATE_TYPES.systemOnboarding]: 'onboardingtemplates',
  [TEMPLATE_TYPES.systemTicketing]: 'ticketingtemplates',
  [TEMPLATE_TYPES.systemClient]: 'clienttemplates',
  [TEMPLATE_TYPES.systemTask]: 'tasktemplates'
};

const TEMPLATE_ROLES = {
  [TEMPLATE_TYPES.systemOnboarding]: 'onboardingNotificationTemplate',
  [TEMPLATE_TYPES.systemTicketing]: 'ticketNotificationTemplate',
  [TEMPLATE_TYPES.systemClient]: 'clientNotificationTemplate',
  [TEMPLATE_TYPES.systemTask]: 'taskNotificationTemplate',
  [TEMPLATE_TYPES.systemAsset]: 'alertNotificationTemplate'
};

const TICKETING_REQUESTER_TEMPLATES = {
  ticketCreated: '1001',
  ticketResolved: '1003',
  ticketClosed: '1004',
  ticketApprovalStatus: '1013'
};

const TICKETING_TECHNICIAN_TEMPLATES = {
  ticketCreated: '1005',
  ticketAssignedTechnician: '1006',
  ticketAssignedTechnicianGroup: '1007',
  slaResponse: '1008',
  slaResolution: '1009',
  requesterReplied: '1010',
  noteAdded: '1011',
  approval: '1012',
  ticketApprovalStatus: '1014',
  approvalAction: '1015'
};

export {
  TEMPLATE_TYPES,
  TEMPLATE_SUB_TYPES,
  TEMPLATE_SUBTYPE_KEYS,
  TEMPLATE_URL_PATHS,
  TEMPLATE_ROLES,
  TICKETING_REQUESTER_TEMPLATES,
  TICKETING_TECHNICIAN_TEMPLATES
};
